import { render, staticRenderFns } from "./WhiteBoard.vue?vue&type=template&id=9cb21446&scoped=true"
import script from "./WhiteBoard.vue?vue&type=script&lang=js"
export * from "./WhiteBoard.vue?vue&type=script&lang=js"
import style1 from "./WhiteBoard.vue?vue&type=style&index=1&id=9cb21446&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb21446",
  null
  
)

export default component.exports